import Vue from 'vue'
import { getSupabase, isBrowserAuthConfigured } from './supabase'

const SUPER_ADMIN_EMAIL = (process.env.VUE_APP_SUPER_ADMIN_EMAIL || 'support@brokurz.com').toLowerCase()

function roleFromUser(user) {
  if (!user) return null
  if (String(user.email || '').toLowerCase() === SUPER_ADMIN_EMAIL) return 'superadmin'
  return (user.app_metadata && user.app_metadata.role)
    || (user.user_metadata && user.user_metadata.role)
    || 'admin'
}

export const authState = new Vue({
  data() {
    return {
      ready: false,
      session: null,
      user: null,
      accessToken: null,
      error: null,
    }
  },
  computed: {
    isAuthenticated() {
      return Boolean(this.user && this.accessToken)
    },
    isSuperAdmin() {
      return roleFromUser(this.user) === 'superadmin'
    },
    email() {
      return this.user && this.user.email
    },
    role() {
      return roleFromUser(this.user)
    },
  },
  methods: {
    applySession(session) {
      this.session = session || null
      this.user = session && session.user ? session.user : null
      this.accessToken = session && session.access_token ? session.access_token : null
    },
    async init() {
      if (!isBrowserAuthConfigured()) {
        this.ready = true
        this.error = 'Auth is not configured'
        return
      }
      const supabase = getSupabase()
      const { data, error } = await supabase.auth.getSession()
      if (error) this.error = error.message
      this.applySession(data && data.session)
      supabase.auth.onAuthStateChange((_event, session) => {
        this.applySession(session)
      })
      this.ready = true
    },
    async signIn(email, password) {
      const supabase = getSupabase()
      const { data, error } = await supabase.auth.signInWithPassword({ email, password })
      if (error) throw error
      this.applySession(data.session)
      return data
    },
    async signOut() {
      const supabase = getSupabase()
      await supabase.auth.signOut()
      this.applySession(null)
    },
    async updatePassword(password) {
      const supabase = getSupabase()
      const { data, error } = await supabase.auth.updateUser({ password })
      if (error) throw error
      return data
    },
    async exchangeCodeFromUrl() {
      const supabase = getSupabase()
      // Handles invite / recovery / magic-link tokens in hash or query
      if (window.location.hash && window.location.hash.includes('access_token')) {
        // supabase-js v2 auto-detects with detectSessionInUrl
        const { data } = await supabase.auth.getSession()
        this.applySession(data && data.session)
        return data && data.session
      }
      const params = new URLSearchParams(window.location.search)
      const code = params.get('code')
      if (code) {
        const { data, error } = await supabase.auth.exchangeCodeForSession(code)
        if (error) throw error
        this.applySession(data.session)
        return data.session
      }
      const { data } = await supabase.auth.getSession()
      this.applySession(data && data.session)
      return data && data.session
    },
  },
})

export function getAccessToken() {
  return authState.accessToken
}
